import React, { useState, useEffect, useRef } from 'react';
import styles from './FJCarousel.module.less';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';

// 手机端轮播图  暂停5s
function FJCarousel({ items = [], autoPlay = true, interval = 5000, className }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [isDragging, setIsDragging] = useState(false);

    const videoRefs = useRef([]);
    const autoPlayRef = useRef(null);

    useEffect(() => {
        if (videoRefs?.current[currentIndex]) {
            videoRefs.current[currentIndex].currentTime = 0;
            videoRefs?.current[currentIndex].play();
        }
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex(prev => (prev + 1) % items.length);
    };
    const prevSlide = () => {
        setCurrentIndex(prev => (prev - 1 + items.length) % items.length);
    };

    // 处理触摸开始
    const handleTouchStart = e => {
        FJUtil.forbidEvent(e);
        setTouchStart(e.targetTouches[0].clientX);
        setIsDragging(true);
        if (autoPlayRef.current) {
            clearInterval(autoPlayRef.current);
        }
    };

    // 处理触摸移动
    const handleTouchMove = e => {
        FJUtil.forbidEvent(e);
        if (!isDragging) return;
        setTouchEnd(e.targetTouches[0].clientX);
    };

    // 处理触摸结束
    const handleTouchEnd = e => {
        FJUtil.forbidEvent(e);
        setIsDragging(false);

        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const minSwipeDistance = 50; // 最小滑动距离

        if (Math.abs(distance) > minSwipeDistance) {
            if (distance > 0) {
                nextSlide();
            } else {
                prevSlide();
            }
        }

        setTouchStart(0);
        setTouchEnd(0);

        // // 重新启动自动播放
        // if (autoPlay) {
        //     startAutoPlay();
        // }
    };

    // 启动自动播放 5s切换
    // const startAutoPlay = () => {
    //     if (autoPlayRef.current) {
    //         clearInterval(autoPlayRef.current);
    //     }
    //     autoPlayRef.current = setInterval(nextSlide, interval);
    // };

    // useEffect(() => {
    //     if (autoPlay) {
    //         startAutoPlay();
    //     }
    //     return () => {
    //         if (autoPlayRef.current) {
    //             clearInterval(autoPlayRef.current);
    //         }
    //     };
    // }, [autoPlay, interval]);

    // 播放结束后5s自动切换
    const _playNext = () => {
        if (autoPlayRef.current) {
            clearTimeout(autoPlayRef.current);
        }
        autoPlayRef.current = setTimeout(nextSlide, interval);
    };

    const renderMedia = (item, index) => {
        if (item.type === 'video') {
            return (
                <video
                    ref={el => (videoRefs.current[index] = el)}
                    src={item.url}
                    className={styles.media}
                    autoPlay={index === currentIndex}
                    muted
                    playsInline
                    controlsList='nodownload nofullscreen noremoteplayback'
                    onEnded={_playNext}
                />
            );
        }
        return <img src={item.url} alt={item.title} className={styles.media} draggable={false} />;
    };
    return (
        <div
            className={classNames(styles.carousel, className)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {items.map((item, index) => (
                <div key={index} className={`${styles.carouselItem} ${index === currentIndex ? styles.active : ''}`}>
                    {renderMedia(item, index)}
                </div>
            ))}

            <div className={styles.dots}>
                {items.map((_, index) => (
                    <span
                        key={index}
                        className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ''}`}
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
            </div>
        </div>
    );
}

export default FJCarousel;
